import React, { useState, useEffect } from 'react';

interface QuestionData {
    question: string;
    correct: string;
    options: string[];
}



const SubstractionWord: React.FC = () => {
    const [showImage, setShowImage] = useState(false);
    const [question, setQuestion] = useState<QuestionData[]>([]);
    const [shuffledOptions, setShuffledOptions] = useState<string[]>([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [userInput, setUserInput] = useState<string>("");
    const [error, setError] = useState(false);
    const [selectedOption, setSelectedOption] = useState<string | null>(null);

    function shuffleArray(array: any[]) {
        for (let i = array.length - 1; i > 0; i--) {
            // Generate a random index
            const randomIndex = Math.floor(Math.random() * (i + 1));

            // Swap elements
            [array[i], array[randomIndex]] = [array[randomIndex], array[i]];
        }
        return array;
    }

    const fetchQuestions = async () => {
        try {
            let data: QuestionData[] = [];

            if (process.env.REACT_APP_DEVELOPMENT !== 'WEB') {
                const response = await fetch(process.env.REACT_APP_API_URL + 'SubstractionWordProblemClassTwo.json');
                data = await response.json();
            } else {
                const module = await import('../../../datas/SubstractionWordProblemClassTwo.json');
                data = module.default;
            }

            const shuffledQuestions = shuffleArray(data);
            setQuestion(shuffledQuestions);
            if (shuffledQuestions.length > 0) {
                setShuffledOptions(shuffleArray(shuffledQuestions[0].options));
            }
        } catch (error) {
            console.error('Error loading data:', error);
        }
    };


    useEffect(() => {

        fetchQuestions();
        document.title = "Mamas Guidance - Class Two - Mathematics - Subtraction - Word Problem"; // Set page title
    }, []);

    const handleSubmit = (option: string) => {
        setSelectedOption(option);
        const correctAnswer = question[currentIndex].correct;

        if (parseInt(option) === parseInt(correctAnswer)) {
            setShowImage(true);
            setTimeout(() => {
                const nextIndex = currentIndex + 1 < question.length ? currentIndex + 1 : 0;
                setCurrentIndex(nextIndex);
                setUserInput("");
                setSelectedOption(null);
                setShowImage(false);
                setError(false);
                setShuffledOptions(shuffleArray(question[nextIndex].options));
            }, 5000);
        } else {
            setError(true);
        }
    };

    return (
        <>

            {
                showImage === false ?
                    <>
                        <div className='contentPart showCenter additionWord'>
                            <div className='questionContainer'>
                                {question.length > 0 && (
                                    <h3 className='questionWord'>{question[currentIndex].question}</h3>
                                )}
                            </div>
                            <div className="optionDiv">
                                {shuffledOptions.map((option, index) => (
                                    <div
                                        key={index}
                                        className={`background-blue ${selectedOption === option
                                            ? parseInt(option) === parseInt(question[currentIndex].correct)
                                                ? 'correct'
                                                : 'errorOptions'
                                            : ''
                                            }`}
                                        onClick={() => handleSubmit(option)}
                                    >
                                        {option}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <div className="contentPart showMiddle">
                            <img style={{ height: '150px' }} className='img-fluid' src={process.env.REACT_APP_WELDONE_LINK} />
                        </div>
                    </>
            }
        </>
    );
};

export default SubstractionWord;